import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TuiCalendarModule,
  TuiHintModule,
  TuiPrimitiveYearMonthPaginationModule,
  TuiTextfieldControllerModule
} from "@taiga-ui/core";
import {
  TuiInputDateRangeModule,
  TuiUnfinishedValidatorModule
} from "@taiga-ui/kit";
import { KwikUIInputDateRangeComponent } from "./input-date-range.component";

@NgModule({
  declarations: [KwikUIInputDateRangeComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiCalendarModule,
    TuiHintModule,
    TuiInputDateRangeModule,
    TuiPrimitiveYearMonthPaginationModule,
    TuiTextfieldControllerModule,
    TuiUnfinishedValidatorModule
  ],
  exports: [KwikUIInputDateRangeComponent]
})
export class KwikUIInputDateRangeModule {}
